<app-admin-header
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
></app-admin-header>

<app-skelitions [hidden]="!skelition" [value]="5" class="mb-2"></app-skelitions>

<div class="container-fluid v4-bg-img" [hidden]="skelition">
  <app-ou-info [data]="ousData"></app-ou-info>

  <div class="card v4-bg-card">
    <p-tabView
      [(activeIndex)]="activeIndex"
      (onChange)="onTabClick(activeIndex)"
      class="centered-tabs ui-tabview v4-dsbrd-btns"
    >
      <p-tabPanel
        *ngFor="let tab of dashboards_names"
        [header]="tab"
        class="ui-tabview"
      >
        <div class="row">
          <div
            *ngFor="let data of currentdata"
            [ngClass]="data.class ? data.class : 'col-md-12'"
          >
            <h3 class="text-center mt-4 v4-color-white">
              {{ data.graphname }}
            </h3>

            <div *ngIf="data.graphtype == 'line'">
              <app-linegraph [data]="data"></app-linegraph>
            </div>

            <div *ngIf="data.graphtype == 'bar'">
              <app-barchart [data]="data"></app-barchart>
            </div>

            <div *ngIf="data.graphtype == 'pie'">
              <app-piechart [data]="data"></app-piechart>
            </div>

            <div *ngIf="data.graphtype == 'stackedbar'">
              <app-stackedbarchart [data]="data"></app-stackedbarchart>
            </div>

            <div *ngIf="data.graphtype == 'tree'">
              <app-treechart [data]="data"></app-treechart>
            </div>

            <div *ngIf="data.graphtype == 'bubble'">
              <app-bubblechart [data]="data"></app-bubblechart>
            </div>

            <div *ngIf="data.graphtype == 'tree-distribution'" class="mt-5">
              <app-tree-distribution [data]="data"></app-tree-distribution>
            </div>

            <div *ngIf="data.graphtype == 'treemap'" class="mt-5">
              <app-tree-map [data]="data"></app-tree-map>
            </div>

            <div *ngIf="data.graphtype == 'multiline'" class="mt-5">
              <app-multilinegraph [data]="data"></app-multilinegraph>
            </div>

            <div *ngIf="data.graphtype == 'table'" class="mt-5">
              <app-datatable [data]="data"></app-datatable>
            </div>

            <!-- <hr class="hr"> -->
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>

<app-footer></app-footer>
